/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Save Export Icon component.
 */
export const SystemSaveExportIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.766 11.1428V19.9251C19.766 20.2013 19.5421 20.4251 19.266 20.4251H4.5C4.22386 20.4251 4 20.2013 4 19.9251V5.15918C4 4.88304 4.22386 4.65918 4.5 4.65918H12.5845' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M20.5959 8V3L15.6172 3.25931' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M20.5955 3L13.1274 10.4681' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemSaveExportIcon;
